import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/observable/of";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import { from as from$ } from "rxjs/observable/from";
import { of as of$ } from "rxjs/observable/of";
import * as CreDtos from "../CRE.dtos";
import { forumApi } from "../services/forum";

import {

  LOGOUT_REQUEST,
  logoutSuccess,
  logoutFailure,
  noLogin,
  
  LOGIN_REQUEST,
  LOGIN_VALIDATE,
  loginSuccess,
  loginFailure,
  RESET_PASSWORD_REQUEST,
  resetPasswordSuccess,
  RESET_PASSWORD_UPDATE_REQUEST,
  resetPasswordUpdateSuccess,
  resetPasswordUpdateFailure
  
  } from "../actions/login.actions";

import {
    getForumListRequest,
      changeActiveTab
    } from "../actions/forum.actions";

    import { getMemberRequest, getMemberSuccess } from "../actions/members.actions";

    
export const resetPasswordUpdateEpic = action$ =>
action$
  .ofType(RESET_PASSWORD_UPDATE_REQUEST)
  .mergeMap(action => {
    return forumApi
      .resetPasswordUpdate(action.email, action.token, action.password)
      .mergeMap(response => { 
        let message = "Please log in with your new password";
        if(!response.success)
        {
          message = "Updating your password failed. Please try again.";
        }
        return concat$(Observable.of(loginFailure({message:message}))); 
      })
      .catch(error =>
        // I don't care for failure... just fire an empty action. the server may choose not to reset the password.
        Observable.of(resetPasswordUpdateSuccess(false))
      )
  });

export const resetPasswordEpic = action$ =>
    action$
      .ofType(RESET_PASSWORD_REQUEST)
      .mergeMap(action => {
        return forumApi
          .resetPassword(action.email)
          .mergeMap(response => { 
            return concat$(Observable.of(loginFailure({message:"Please check your email for reset instructions"}))); 
          })
          .catch(error =>
            // I don't care for failure... just fire an empty action. the server may choose not to reset the password.
            Observable.of(loginFailure(error))
          )
      });

export const loginEpic = action$ =>
  action$
    .ofType(LOGIN_REQUEST)
    .mergeMap(action => {
      return forumApi
        .login(action.email, action.password, action.rememberMe)
        .mergeMap(response => { 
          forumApi.saveAuthUser(response.userId, response.userName, response.bearerToken);
          return concat$(Observable.of(loginSuccess(response.userId, response.userName, response.bearerToken))
          , Observable.of(getMemberRequest(response.userId))); 
        })
        .catch(error =>
          Observable.of(loginFailure(error.responseStatus))
        )
    });

export const loginValidateEpic = action$ =>
    action$
      .ofType(LOGIN_VALIDATE)
      .mergeMap(action => 
        forumApi
        .validate()
        .mergeMap(response => { 
          return concat$(Observable.of(getMemberSuccess(response)), Observable.of(getForumListRequest(response.member.email))); 
          /*
          if(response != null && response.token){
              //return concat$(Observable.of(loginSuccess(response.userId, response.email, response.token)), Observable.of(getMemberRequest(response.userId))); 
              
          } else{
            return concat$(Observable.of(noLogin()));
          }*/
        })
        .catch(error =>
          Observable.of(loginFailure(error))
        )
      );

export const logoutEpic = action$ =>
    action$
      .ofType(LOGOUT_REQUEST)
      .mergeMap(action =>
        forumApi
          .logout(action.email)
          .map(response => logoutSuccess())
          .catch(error =>
            Observable.of(logoutFailure(error.responseStatus))
          )
      );


// WEBPACK FOOTER //
// ./src/epics/login.epic.ts